module.exports = __webpack_public_path__ + "img/amio.d4f8e9cb.svg";